import { styled } from '@mui/material';
import { LabelSmall } from 'v3/shared/typography/LabelSmall';
import { theme } from 'v3/styles/global-styles';

export const Wrapper = styled('div')(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  padding: '0.5rem 0',

  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: '2rem',
  },
}));

export const LeftContent = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
  width: '100%',

  [theme.breakpoints.up('md')]: {
    width: '50%',
  },
}));

export const RightContent = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '0.5rem',
  width: '100%',

  [theme.breakpoints.up('md')]: {
    width: '50%',
    alignItems: 'flex-end',
    textAlign: 'right',
  },
}));

export const FlexContainer = styled('div')(() => ({
  display: 'flex',
  gap: '0.5rem',
  alignItems: 'center',
  width: '100%',
  flexWrap: 'wrap',

  [theme.breakpoints.up('md')]: {
    width: 'auto',
    justifyContent: 'flex-end',
  },
}));

export const ImportantText = styled('div')(() => ({
  fontSize: '0.95rem',
  lineHeight: 1.3,
  color: theme.palette.text.primary,
  strong: {
    color: theme.palette.text.primary,
  },
  span: {
    color: theme.palette.secondary.main,
    fontWeight: 600,
  },
}));

export const MutedText = styled('div')(() => ({
  fontSize: '0.9rem',
  lineHeight: 1.3,
  color: theme.palette.secondary.light,
}));

export const CustomLabelSmall = styled(LabelSmall)(({ theme }) => ({
  display: 'flex',
  textDecoration: 'underline',
  color: theme.palette.warning.main,
  cursor: 'pointer',
  alignItems: 'center',
}));

export const AlignText = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
}));
